import ApiResponseBase from '../../../../Base/Domain/ApiResponseBase';
import PaymentDetailsModel from '../PaymentDetailsModel';

class GetPaymentResponseModel extends ApiResponseBase {

  constructor(params) {

    super(params);

    if (typeof params === 'undefined' || params === null) {
      return;
    }

    this.Payment = new PaymentDetailsModel(params.adminPayment);

  }

}

export default GetPaymentResponseModel;